<!--
 * @Author: 李明明
 * @Date: 2022-10-24 17:18:14
 * @LastEditTime: 2022-10-24 17:37:30
 * @LastEditors: 李明明
 * @Description: 
 * @FilePath: /ykt-micro-main/src/views/transfer/course_detail.vue
 * 代码版权方：'政府采购信息网'
-->
<template>
  <div></div>
</template>

<script setup>
import { onMounted } from 'vue'
import {useRouter,useRoute} from 'vue-router'

const router = useRouter()
const route = useRoute()

onMounted(()=>{
  const id = route.params.id;
  if(+id){
    router.push({
      path: '/sign_detail',
      query:{
          courseId: id,
          tabId: '0',
        }
    })
  }else{
    router.push({
      path: '/'
    })
  }
})
</script>
<!-- <script>
export default {
  name: "courseDetail",
  mounted() {
    let id = this.$route.params.id
    if (+id){
      this.$router.push({
        name: "SignDetail",
        query:{
          courseId: id,
          tabId: '0',
        }
      })
    }else {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script> -->